<template>
  <el-dialog :close-on-click-modal="false" :visible="viewVisible" :modal-append-to-body='false' @close="closeDetailForm">
    <el-tabs v-model="viewName">
      <el-tab-pane label="详情" name="detailForm">
        <el-form :model="detailForm" ref="detailForm" size="mini" class="detail_form">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="基本信息" name="basicInformation">
              <el-col :span="12">
                <el-form-item label="桩类型型号：" :label-width="formLabelWidth" prop="typeModel">
                  <label v-text="detailForm.typeModel"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="桩类型名称：" :label-width="formLabelWidth" prop="typeName">
                  <label v-text="detailForm.typeName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="额定功率：" :label-width="formLabelWidth" prop="ratedPower">
                  <label v-text="detailForm.ratedPower"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="输出电压范围(VDC)：" :label-width="formLabelWidth" prop="outputVoltageRange">
                  <label v-text="detailForm.outputVoltageRange"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="输出电流范围(A)：" :label-width="formLabelWidth" prop="outputCurrentRange">
                  <label v-text="detailForm.outputCurrentRange"></label>
                </el-form-item>
              </el-col>
              <!--                  <el-col :span="12">-->
              <!--                    <el-form-item label="每把枪均充电流范围（A）：" :label-width="formLabelWidth" prop="chargingCurrentRangePerGun">-->
              <!--                      <label v-text="detailForm.chargingCurrentRangePerGun"></label>-->
              <!--                    </el-form-item>-->
              <!--                  </el-col>-->
              <el-col :span="12">
                <el-form-item label="功率分配方式：" :label-width="formLabelWidth" prop="powerDistributionMode">
                  <label v-if="detailForm.powerDistributionMode" v-text="detailForm.powerDistributionMode.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="枪线长度(米)：" :label-width="formLabelWidth" prop="lineLength">
                  <label v-text="detailForm.lineLength"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="充电枪数量：" :label-width="formLabelWidth" prop="gunCount">
                  <label v-text="detailForm.gunCount"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否带广告机：" :label-width="formLabelWidth" prop="advertisingMachine">
                  <label v-if="detailForm.advertisingMachine"
                         v-text="detailForm.advertisingMachine.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="模块品牌型号：" :label-width="formLabelWidth" prop="moduleBrandModel">
                  <label v-text="detailForm.moduleBrandModel"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="模块功率(kw)：" :label-width="formLabelWidth" prop="modularPower">
                  <label v-text="detailForm.modularPower"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="模块数量：" :label-width="formLabelWidth" prop="modularCount">
                  <label v-text="detailForm.modularCount"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="整机重量（KG）：" :label-width="formLabelWidth" prop="completeMachineWeight">
                  <label v-text="detailForm.completeMachineWeight"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="软件版本号：" :label-width="formLabelWidth" prop="versionNumber">
                  <label v-text="detailForm.versionNumber"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电流（区间）：" :label-width="formLabelWidth" prop="currentRange">
                  <label v-text="detailForm.currentRange"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电压（区间）：" :label-width="formLabelWidth" prop="voltageRange">
                  <label v-text="detailForm.voltageRange"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="功率（区间）：" :label-width="formLabelWidth" prop="powerRange">
                  <label v-text="detailForm.powerRange"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
  export default {
    name: "detail",
    data(){
      return{
        viewName: 'detailForm',
        activeNames: ['basicInformation'],
        formLabelWidth: '150px',
      }
    },
    props:{
      viewVisible:false,
      detailForm: {},
    },
    methods:{
      closeDetailForm(){
        this.$emit("closeDetailForm")
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/typeManager/detail.vue